import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import { call } from "redux-saga/effects";
import { persistor } from "../store";
import { dictionaryError } from '../utils/dictionary';
import { t } from "i18next";

export const tokenConfig = {
  expirationTime: 1, // 1 hour token expiration
  delayAlert: 10, // 10 minutes before token expire show toast alert
}

// Vérifie si le token a expiré
export const checkTokenExpired = () => {
    const previousTime = localStorage.getItem('dateToken');
    if (previousTime) {
        const tokenTime = moment(previousTime);
        const currentTime = moment();
        const expirationTime = tokenTime.clone().add(tokenConfig.expirationTime, 'hours'); // Ajoute heures

        if (currentTime.isAfter(expirationTime)) {
            persistor.purge();
            localStorage.removeItem('dateToken');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('user');
            return {'logout': true};
        }

        const delay = expirationTime.diff(currentTime, 'minutes'); // Diffrence en minutes
        if(delay === tokenConfig.delayAlert) {
          return {'logout': false, session: true};
        }
        
    }
    return {'logout': false};
};

let expiredTimer;

// Gère l'expiration automatique du token
export const tokenExpired = () => {
    const expirationTime = moment().add(tokenConfig.expirationTime, 'hours');
    const timeLeft = expirationTime.diff(moment(), 'milliseconds'); // Différence en millisecondes

    clearTimeout(expiredTimer);

    expiredTimer = setTimeout(() => {
        persistor.purge();
        localStorage.removeItem('accessToken');
        localStorage.removeItem('user');
        window.location.href = '/login';
    }, timeLeft);
};

// Configure la session utilisateur
export const setSession = (accessToken) => {
    if (accessToken) {
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('dateToken', moment().toISOString()); // Sauvegarde la date actuelle au format ISO


        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

        // Configure le timer d'expiration
        //tokenExpired();
        checkTokenExpired()
    } else {
        persistor.purge();
        localStorage.removeItem('accessToken');
        localStorage.removeItem('dateToken');
        localStorage.removeItem('user');
        delete axios.defaults.headers.common.Authorization;
        window.location.href = '/login';
    }
};


// Utilitaire pour formater les dates au format "yyyy-MM-dd"
export const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
};

export const getUniqueKeys = (routes) => {
    const keys = routes.map(route => route.key).filter(key => key);
    return [...new Set(keys)];
};

// Function to join array elements with '/'
export const joinArrayWithSlash = (array) => {
    return array?.join(' / ') || '';
};

/**
 * Fonction pour obtenir la date du premier jour du mois
 * @param {Object} dateObj - Objet contenant le mois et l'année
 * @param {number} dateObj.month - Numéro du mois (1-12)
 * @param {number} dateObj.year - Année
 * @returns {moment.Moment} - Premier jour du mois sous forme d'objet moment
 */
export const getFirstDayOfMonth = (dateObj) => {
    if (!dateObj || typeof dateObj.month !== 'number' || typeof dateObj.year !== 'number') {
      throw new Error('Invalid date object');
    }
  
    // Créer un objet moment à partir de l'année et du mois fournis
    return moment({ year: dateObj.year, month: dateObj.month - 1, day: 1 }).toISOString();
};

/**
 * Fonction pour obtenir la date du dernier jour du mois
 * @param {Object} dateObj - Objet contenant le mois et l'année
 * @param {number} dateObj.month - Numéro du mois (1-12)
 * @param {number} dateObj.year - Année
 * @returns {moment.Moment} - Dernier jour du mois sous forme d'objet moment
 */
export const getLastDayOfMonth = (dateObj) => {
    if (!dateObj || typeof dateObj.month !== 'number' || typeof dateObj.year !== 'number') {
      throw new Error('Invalid date object');
    }
  
    // Créer un objet moment pour le premier jour du mois suivant
    const firstDayOfNextMonth = moment({ year: dateObj.year, month: dateObj.month, day: 1 });
  
    // Soustraire un jour pour obtenir le dernier jour du mois courant
    return firstDayOfNextMonth.subtract(1, 'day').toISOString();
};

// Fonction pour générer les mois entre deux dates
export const generateMonthLabels = (startMonth, endMonth) => {
    const labels = [];
    let current = moment({ year: startMonth.year, month: startMonth.month - 1, day: 1 });
  
    const end = moment({ year: endMonth.year, month: endMonth.month - 1, day: 1 });
  
    while (current.isSameOrBefore(end, 'month')) {
      labels.push(current.format('MMMM-YYYY'));
      current.add(1, 'month');
    }
  
    return labels;
};

export const generateMonthLabelsYYYYMM = (startMonth, endMonth) => {
    const labels = [];
    
    // Crée un moment pour le mois de début
    let current = moment({ year: startMonth.year, month: startMonth.month - 1, day: 1 });
  
    // Crée un moment pour le mois de fin
    const end = moment({ year: endMonth.year, month: endMonth.month - 1, day: 1 });
  
    // Continue d'ajouter des mois tant que current est antérieur ou égal à end
    while (current.isSameOrBefore(end, 'month')) {
        labels.push(current.format('YYYY-MM')); // Format YYYY-MM
        current.add(1, 'month');
    }
  
    return labels;
};

export const calculateMonthlyAverages = (data) => {
    const monthlySums = {};
    const monthlyCounts = {};
  
    data && data.forEach(item => {
      Object.keys(item.globalEval).forEach(key => {
        if (item.globalEval[key] !== null) {
          const [year, month] = key.split('-');
          const yearMonth = `${year}-${month}`;
          
          if (!monthlySums[yearMonth]) {
            monthlySums[yearMonth] = 0;
            monthlyCounts[yearMonth] = 0;
          }
  
          monthlySums[yearMonth] += item.globalEval[key];
          monthlyCounts[yearMonth] += 1;
        }
      });
    });
  
    const monthlyAverages = {};
    Object.keys(monthlySums).forEach(key => {
      monthlyAverages[key] = monthlySums[key] / monthlyCounts[key];
    });
  
    return monthlyAverages;
};
  

export const prepareSeriesData = (monthlyAverages, labels) => {
    const data = labels.map((label) => {
      const value = monthlyAverages[label] || null;
      return value;
    });
  
    // Only include points where value is not null
    const filteredData = data.map((value, index) => value !== null ? { x: labels[index], y: value } : null).filter(item => item !== null);
  
    return [{ data: filteredData }];
};
  
export const getColorByScore = (score) => {
    let color;
    switch(score){
      case 'Success':
        color = 'green';
        break;
      case 'Warning':
        color = 'orange';
        break;
      case 'Danger':
        color = 'red';
        break;
      default:
        color = 'grey';
        break;
    }
    return color;
};


export const getActivities = () => {
  return [
    'DISTRIBUTORS',
    'ADAPTED_COMPANY',
    'EVENT',
    'MANUFACTURER',
    'ENGINEERING',
    'NATIONAL_INSTALLER',
    'REGIONAL_INSTALLER',
    'LOCAL_INSTALLER',
    'PANEL_BUILDER',
    'OTHERS'
  ];
};

export const getDiscount = (activity) => {
  const discountsByActivity = {
    'DISTRIBUTORS': 60,
    'ADAPTED_COMPANY': 30,
    'OTHERS': 30,
    'EVENT': 55,
    'MANUFACTURER': 55,
    'ENGINEERING': 45,
    'NATIONAL_INSTALLER': 60,
    'REGIONAL_INSTALLER': 55,
    'LOCAL_INSTALLER': 50,
    'PANEL_BUILDER': 55
  };

  if (!activity || typeof activity !== 'string') {
    return 0;
  }

  const normalizedActivity = activity.toUpperCase().trim();

  return discountsByActivity[normalizedActivity] || 0;
};

export const getErrorFromResponse = (error, entity) => {
  if (!error) return "unknown";

  if (error.data?.errors && error.data.errors.length > 0) {
    const firstError = error.data.errors[0];
    
    if (dictionaryError[entity]) {
      const dictError = dictionaryError[entity].find(e => e.code === firstError.code);
      if (dictError) {

         if (firstError.key) return  { key: firstError.key, error: dictError.message };

        return dictError.message;
      }
    }

    if (firstError.originalErr) {
      return firstError.originalErr;
    }
  }

  if (error.message) {
    const genericError = dictionaryError.generic.find(e => e.code === error.message);
    return genericError?.message;
  }

  return "unknown";
};

export const getErrorMessage = (error) => {
  if (error.data && error.data.errors && error.data.errors[0] && error.data.errors[0].code) {
    return t(error.data.errors[0].code);
  }
  return t('GENERIC_ERROR');
};

/* ------------------ REDUX ------------------ */

export const reduxSerializedError = (error) => {
  return {
    message: error.message || 'GENERIC_ERROR',
    statusCode: error.response?.status,
    data: error.response?.data
  };
}
/* ------------------------------------------- */

export const getCurrentTheme = () => {
  return document.documentElement.getAttribute('data-bs-theme') === 'dark' ? 'dark' : 'light';
};